import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { GooglePayLandingPage } from "./GooglePayLandingPage";
import { GooglePayPersonalData } from "./GooglePayPersonalData";
import { GooglePayRoutes } from "./GooglePayRoutes";
import { GooglePaySigning } from "./GooglePaySigning";
import { GooglePayStore } from "./GooglePayStore";
import { GooglePaySuccess } from "./GooglePaySuccess";
import { GooglePaySummary } from "./GooglePaySummary";
import { PdfViewer } from "components/common/PdfViewer";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class GooglePayContainer extends React.Component<IProps> {
    store: GooglePayStore;

    constructor(props: IProps) {
        super(props);
        this.store = new GooglePayStore();
    }

    async componentDidMount() {
        pushRoute(GooglePayRoutes.ROOT);
        try {
            georgeWebHeaderStore.configure({
                title: ui.__("googlePay.document.title"),
            });

            if (auth.authorized) {
                await this.store.loadData();

                if (this.store.approvalResponse?.approved) {
                    pushRoute(GooglePayRoutes.SUCCESS);
                }
            }
        } catch (error) {
            debug.log("### GooglePayContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("googlePay.document.title");
        return (
            <div>
                <Route exact path={GooglePayRoutes.ROOT} component={this.withStore(GooglePayLandingPage)} />
                <Route exact path={GooglePayRoutes.PERSONAL_DATA} component={this.withStore(GooglePayPersonalData)} />
                <Route exact path={GooglePayRoutes.SUMMARY} component={this.withStore(GooglePaySummary)} />
                <Route exact path={GooglePayRoutes.SIGNING} component={this.withStore(GooglePaySigning)} />
                <Route exact path={GooglePayRoutes.SUCCESS} component={this.withStore(GooglePaySuccess)} />
                <Route path={GooglePayRoutes.PDF} component={() => <PdfViewer {...this.props} uint8Data={this.store.pdfData} />} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/googlePay/GooglePayContainer.tsx